module.exports = __webpack_public_path__ + "img/ill_3.4f1d8b1c.png";